var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHepaOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HEPA_OFF",
    "data-name": "HEPA OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M5.15,42.71h38.7a3.862,3.862,0,0,0,3.86-3.86V5.16A3.862,3.862,0,0,0,43.85,1.3H5.15A3.862,3.862,0,0,0,1.29,5.16V38.85A3.862,3.862,0,0,0,5.15,42.71Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M43.87,44H5.13A5.145,5.145,0,0,1,0,38.85V5.15A5.145,5.145,0,0,1,5.13,0H43.87A5.145,5.145,0,0,1,49,5.15V38.86A5.143,5.143,0,0,1,43.87,44ZM5.13,2.59A2.556,2.556,0,0,0,2.58,5.15V38.86a2.556,2.556,0,0,0,2.55,2.56H43.87a2.556,2.556,0,0,0,2.55-2.56V5.15a2.556,2.556,0,0,0-2.55-2.56H5.13Z",
    fill: "#6a7084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M6.78,15.55v4.87h5.15V15.55h2.22V27.72H11.93V22.36H6.78v5.36H4.56V15.55Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M14.47,28.04H11.6V22.68H7.1v5.36H4.24V15.23H7.1V20.1h4.5V15.23h2.87Zm-2.22-.64h1.58V15.88H12.25v4.87H6.46V15.88H4.88V27.4H6.46V22.04h5.79Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M23.5,22.32H18.91v3.57h5.13v1.82H16.69V15.55h7.08v1.82H18.91v3.14H23.5Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M24.37,28.04h-8V15.23H24.1V17.7H19.24v2.49h4.59v2.45H19.24v2.93h5.13v2.47Zm-7.36-.64h6.71V26.22H18.59V22h4.59V20.84H18.59V17.05h4.86V15.87H17.01Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M25.99,15.72a19.861,19.861,0,0,1,3.4-.25,5.5,5.5,0,0,1,3.59.99,3.445,3.445,0,0,1,1.19,2.69,3.662,3.662,0,0,1-1.05,2.76,5.4,5.4,0,0,1-3.85,1.3,6.739,6.739,0,0,1-1.08-.07v4.58h-2.2v-12Zm2.2,5.66a4.572,4.572,0,0,0,1.08.09c1.66,0,2.67-.81,2.67-2.24,0-1.35-.94-2.08-2.48-2.08a5.7,5.7,0,0,0-1.28.11v4.12Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M28.51,28.04H25.66V15.44l.27-.05a19.972,19.972,0,0,1,3.45-.26,5.836,5.836,0,0,1,3.8,1.07,3.769,3.769,0,0,1,1.31,2.94,4.007,4.007,0,0,1-1.15,3,5.7,5.7,0,0,1-4.07,1.39c-.29,0-.54-.01-.76-.03Zm-2.2-.64h1.56V22.75l.38.07a6.471,6.471,0,0,0,1.02.07,5.062,5.062,0,0,0,3.62-1.21,3.34,3.34,0,0,0,.95-2.53,3.121,3.121,0,0,0-1.07-2.44,5.238,5.238,0,0,0-3.39-.92,20.77,20.77,0,0,0-3.07.2V27.4Zm2.96-5.6a4.688,4.688,0,0,1-1.16-.1l-.24-.06V17.02l.25-.06a5.817,5.817,0,0,1,1.35-.12c1.75,0,2.8.9,2.8,2.4C32.27,20.82,31.12,21.8,29.27,21.8Zm-.76-.68a6.937,6.937,0,0,0,.76.04c1.49,0,2.35-.7,2.35-1.91,0-1.53-1.35-1.75-2.15-1.75a6.64,6.64,0,0,0-.96.06v3.56Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M37.24,24.27l-1.05,3.45H33.9l3.9-12.17h2.84l3.95,12.17H42.2l-1.1-3.45Zm3.48-1.68-.96-3c-.23-.74-.43-1.57-.61-2.27h-.04c-.18.7-.36,1.55-.58,2.27l-.94,3Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M45.03,28.04H41.97l-1.1-3.45H37.48l-1.05,3.45H33.46l4.11-12.81h3.3Zm-2.59-.64h1.7L40.4,15.88H38.03L34.34,27.4h1.61L37,23.95h4.34Zm-1.27-4.48H37.16l1.07-3.42c.14-.48.27-1.01.39-1.52.06-.25.12-.5.18-.73l.06-.25h.5l.1.24.1.38c.15.6.32,1.27.51,1.88Zm-3.13-.65h2.24l-.82-2.57c-.11-.36-.22-.74-.32-1.11-.09.38-.19.76-.29,1.11Z",
    fill: "#404041"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHepaOff);
export default __webpack_public_path__ + "static/media/hepa_off.00c7700fb00c023765429274617ba5f0.svg";
export { ForwardRef as ReactComponent };